// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Is from "../../helpers/Is.res.js";
import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../../resources/images-and-icons/Icon.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as View from "../../primitives/View.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as BackendFailure from "../../resources/data-visualizations/BackendFailure.res.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as LabelTableCell from "../TableCell/LabelTableCell.res.js";
import * as SettingsRoutes from "../../app/Settings/SettingsRoutes.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as CanaryDisclosure from "../../resources/data-visualizations/CanaryDisclosure.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ElectronicInvoicing from "./ElectronicInvoicing.res.js";
let label = I18n.t("electronic_invoicing_workflow_state.label");
let Raw = {};
let query = Client.gql(["fragment ElectronicInvoicingWorkflowStateResultFragment on ElectronicInvoicingWorkflowStateResult   {\n__typename  \nvalue  {\n__typename  \nstatus  \nskipReason  \nissues  {\n__typename  \nkind  \nmessage  \ndata  \n}\n\n}\n\nfailures  {\n__typename  \nkind  \nmessage  \ndata  \n}\n\n}\n"]);
function parse(value) {
  let value$1 = value.value;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.status;
    let tmp$1;
    switch (value$2) {
      case "postPublicationBlocked":
        tmp$1 = "postPublicationBlocked";
        break;
      case "postPublicationCompleted":
        tmp$1 = "postPublicationCompleted";
        break;
      case "postPublicationStarted":
        tmp$1 = "postPublicationStarted";
        break;
      case "publicationBlocked":
        tmp$1 = "publicationBlocked";
        break;
      case "publicationNotApplicable":
        tmp$1 = "publicationNotApplicable";
        break;
      case "publicationPending":
        tmp$1 = "publicationPending";
        break;
      case "publicationRequired":
        tmp$1 = "publicationRequired";
        break;
      case "publicationSkipped":
        tmp$1 = "publicationSkipped";
        break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    let value$3 = value$1.skipReason;
    let tmp$2;
    if (value$3 == null) {
      tmp$2 = undefined;
    } else {
      let tmp$3 = value$3 === "b2cInvoice" ? "b2cInvoice" : {
        NAME: "FutureAddedValue",
        VAL: value$3
      };
      tmp$2 = tmp$3;
    }
    let value$4 = value$1.issues;
    tmp = {
      __typename: value$1.__typename,
      status: tmp$1,
      skipReason: tmp$2,
      issues: value$4.map(value => ({
        __typename: value.__typename,
        kind: value.kind,
        message: value.message,
        data: value.data
      }))
    };
  }
  let value$5 = value.failures;
  return {
    __typename: value.__typename,
    value: tmp,
    failures: value$5.map(value => ({
      __typename: value.__typename,
      kind: value.kind,
      message: value.message,
      data: value.data
    }))
  };
}
function serialize(value) {
  let value$1 = value.failures;
  let failures = value$1.map(value => {
    let value$1 = value.data;
    let value$2 = value.message;
    let value$3 = value.kind;
    let value$4 = value.__typename;
    return {
      __typename: value$4,
      kind: value$3,
      message: value$2,
      data: value$1
    };
  });
  let value$2 = value.value;
  let value$3;
  if (value$2 !== undefined) {
    let value$4 = value$2.issues;
    let issues = value$4.map(value => {
      let value$1 = value.data;
      let value$2 = value.message;
      let value$3 = value.kind;
      let value$4 = value.__typename;
      return {
        __typename: value$4,
        kind: value$3,
        message: value$2,
        data: value$1
      };
    });
    let value$5 = value$2.skipReason;
    let skipReason = value$5 !== undefined ? typeof value$5 === "object" ? value$5.VAL : "b2cInvoice" : null;
    let value$6 = value$2.status;
    let status = typeof value$6 === "object" ? value$6.VAL : value$6 === "postPublicationCompleted" ? "postPublicationCompleted" : value$6 === "publicationNotApplicable" ? "publicationNotApplicable" : value$6 === "postPublicationStarted" ? "postPublicationStarted" : value$6 === "publicationPending" ? "publicationPending" : value$6 === "postPublicationBlocked" ? "postPublicationBlocked" : value$6 === "publicationSkipped" ? "publicationSkipped" : value$6 === "publicationBlocked" ? "publicationBlocked" : "publicationRequired";
    let value$7 = value$2.__typename;
    value$3 = {
      __typename: value$7,
      status: status,
      skipReason: skipReason,
      issues: issues
    };
  } else {
    value$3 = null;
  }
  let value$8 = value.__typename;
  return {
    __typename: value$8,
    value: value$3,
    failures: failures
  };
}
function verifyArgsAndParse(_ElectronicInvoicingWorkflowStateResultFragment, value) {
  return parse(value);
}
function verifyName(_fragmentName) {}
let ResultFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};
function backendFailure(param) {
  return BackendFailure.make(param.kind, param.data, param.message);
}
function failureKindToTitle(value) {
  switch (value) {
    case "DuplicateElectronicInvoice":
    case "ElectronicInvoicePostPublicationIssue":
    case "InvalidVatIdentificationNumber":
    case "MissingUblPartyCityName":
    case "MissingUblPartyPeppolParticipantEndpoint":
    case "MissingUblPartyStreetName":
    case "MissingVatIdentificationNumber":
    case "PublishElectronicInvoice":
    case "UnexpectedIdentificationIdScheme":
      break;
    default:
      return value;
  }
  return I18n.t("sales_details_page.electronic_invoicing_workflow_state_card.backend_failure." + value + ".title");
}
function skipReasonToMessage(value) {
  if (typeof value === "object") {
    return value.VAL;
  } else {
    return I18n.t("sales_details_page.electronic_invoicing_workflow_state_card.backend_skip_reason.b2cInvoice.message");
  }
}
function map(data) {
  let failures = data.failures;
  let value = data.value;
  if (Is.notEmpty(failures)) {
    return {
      TAG: "Failures",
      _0: failures
    };
  }
  let issues = Stdlib_Option.mapWithDefault(value, [], value => value.issues);
  let skipReason = Stdlib_Option.flatMap(value, value => value.skipReason);
  let match = Stdlib_Option.map(value, value => value.status);
  if (match === undefined) {
    return {
      TAG: "Failures",
      _0: []
    };
  }
  if (typeof match === "object") {
    return {
      TAG: "UnknownStatus",
      _0: match.VAL
    };
  }
  if (match === "postPublicationCompleted") {
    return "PostPublicationCompleted";
  }
  if (match === "publicationNotApplicable") {
    return "PublicationNotApplicable";
  }
  if (match === "postPublicationStarted") {
    return "PostPublicationStarted";
  }
  if (match === "publicationPending") {
    return "PublicationPending";
  }
  if (match === "postPublicationBlocked") {
    return {
      TAG: "PostPublicationBlocked",
      _0: issues
    };
  }
  if (match !== "publicationSkipped") {
    if (match === "publicationBlocked") {
      return {
        TAG: "PublicationBlocked",
        _0: issues
      };
    } else {
      return "PublicationRequired";
    }
  }
  let skipReason$1 = Stdlib_Option.getOr(skipReason, {
    NAME: "FutureAddedValue",
    VAL: "unknown_skip_reason"
  });
  return {
    TAG: "PublicationSkipped",
    _0: skipReason$1
  };
}
function ElectronicInvoicingWorkflowState$StatusBadge(props) {
  let size = props.compact ? "M" : "L";
  let status = map(props.data);
  let exit = 0;
  if (typeof status !== "object") {
    switch (status) {
      case "PublicationNotApplicable":
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      case "PublicationRequired":
        return JsxRuntime.jsx(Badge.make, {
          children: I18n.t("To Send"),
          iconSvg: JsxRuntime.jsx(Icon.make, {
            name: Icon.typeFromNext("Send"),
            fill: "#7E22CE",
            width: 12,
            height: 12,
            bold: true
          }),
          size: Badge.sizeFromNext(size),
          borderColor: "#C37DFF",
          backgroundColor: "#F3E8FF",
          foregroundColor: "#7E22CE"
        });
      case "PublicationPending":
      case "PostPublicationStarted":
        exit = 1;
        break;
      case "PostPublicationCompleted":
        return JsxRuntime.jsx(NextBadge.make, {
          kind: "Information",
          label: I18n.t("Published"),
          size: size,
          icon: "StatusOk"
        });
    }
  } else {
    switch (status.TAG) {
      case "Failures":
        return JsxRuntime.jsx(BackendFailure.Icon.make, {});
      case "UnknownStatus":
        return JsxRuntime.jsx(LabelTableCell.make, {
          label: status._0
        });
      case "PublicationSkipped":
        return JsxRuntime.jsx(NextBadge.make, {
          kind: "Neutral",
          label: I18n.t("Excluded"),
          size: size,
          icon: "Exit"
        });
      case "PublicationBlocked":
      case "PostPublicationBlocked":
        exit = 2;
        break;
    }
  }
  switch (exit) {
    case 1:
      return JsxRuntime.jsx(NextBadge.make, {
        kind: "Important",
        label: I18n.t("Ongoing"),
        size: size,
        icon: "Hourglass"
      });
    case 2:
      return JsxRuntime.jsx(NextBadge.make, {
        kind: "Danger",
        label: I18n.t("Error"),
        size: size,
        icon: "StatusNotOk"
      });
  }
}
let StatusBadge = {
  make: ElectronicInvoicingWorkflowState$StatusBadge
};
function ElectronicInvoicingWorkflowState$OptionalStatusBadge(props) {
  let __compact = props.compact;
  let compact = __compact !== undefined ? __compact : false;
  return Stdlib_Option.mapOr(props.data, JsxRuntime.jsx(Placeholder.NA.make, {}), data => JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadge, {
    data: data,
    compact: compact
  }));
}
let OptionalStatusBadge = {
  make: ElectronicInvoicingWorkflowState$OptionalStatusBadge
};
function ElectronicInvoicingWorkflowState$IssueBox(props) {
  let data = props.data;
  return JsxRuntime.jsx(NextBanner.make, {
    children: data.message,
    variation: "danger",
    title: failureKindToTitle(data.kind),
    maxLines: 2,
    expandLabel: I18n.t("See more"),
    expandLabelEmphasis: true,
    onPressCopy: () => {
      let text = Stdlib_Option.getOr(JSON.stringify(data, null, 2), "");
      let clipboard = window.navigator.clipboard;
      clipboard.writeText(text);
    }
  });
}
let IssueBox = {
  make: ElectronicInvoicingWorkflowState$IssueBox
};
function ElectronicInvoicingWorkflowState$PublicationSkippedInfoBox(props) {
  return JsxRuntime.jsx(NextBanner.make, {
    children: skipReasonToMessage(props.reason),
    variation: "neutral"
  });
}
let PublicationSkippedInfoBox = {
  make: ElectronicInvoicingWorkflowState$PublicationSkippedInfoBox
};
function ElectronicInvoicingWorkflowState$DataBoxList(props) {
  let data = map(props.data);
  if (typeof data !== "object") {
    return null;
  }
  switch (data.TAG) {
    case "Failures":
      return JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(BackendFailure.List.make, {
          data: data._0,
          backendFailure: backendFailure
        }),
        spaceTop: "normal"
      });
    case "PublicationSkipped":
      return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$PublicationSkippedInfoBox, {
        reason: data._0
      });
    case "PublicationBlocked":
    case "PostPublicationBlocked":
      break;
    default:
      return null;
  }
  return JsxRuntime.jsx(Stack.make, {
    children: View.mapWithIndexKey(data._0, (data, key) => JsxRuntime.jsx(ElectronicInvoicingWorkflowState$IssueBox, {
      data: data
    }, key)),
    space: "small"
  });
}
let DataBoxList = {
  make: ElectronicInvoicingWorkflowState$DataBoxList
};
function isCardContentExpandable(data) {
  let match = map(data);
  if (typeof match !== "object") {
    return false;
  }
  switch (match.TAG) {
    case "Failures":
    case "PublicationSkipped":
    case "PublicationBlocked":
    case "PostPublicationBlocked":
      return true;
    default:
      return false;
  }
}
let i18nPrefix = "sales_details_page.electronic_invoicing_workflow_state_card.";
function ElectronicInvoicingWorkflowState$CardContent(props) {
  let enrollmentAgreementLink = props.enrollmentAgreementLink;
  let __receivingEnabled = props.receivingEnabled;
  let data = props.data;
  let receivingEnabled = __receivingEnabled !== undefined ? __receivingEnabled : false;
  let navigate = Navigation.useNavigate();
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(CanaryDisclosure.make, {
      children: JsxRuntime.jsx(ElectronicInvoicingWorkflowState$DataBoxList, {
        data: data
      }),
      title: label,
      headerEndElement: JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadge, {
          data: data,
          compact: true
        }),
        space: "small"
      }),
      defaultExpanded: true,
      expandable: isCardContentExpandable(data)
    }), JsxRuntime.jsx(InputTextField.make, {
      label: I18n.t(i18nPrefix + "customer_ei_address.label"),
      disabled: true,
      placeholder: Placeholder.NA.text,
      value: ElectronicInvoicing.InvoicingEndpoint.formatOption(props.customerInvoicingAddress)
    }), View._if(!receivingEnabled, () => JsxRuntime.jsx(CanarySurface.make, {
      tone: "neutral-ghost",
      borderStyle: "dashed",
      children: JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Icon.make, {
              name: "status_info",
              fill: "#25243A",
              width: 18,
              height: 18,
              bold: true
            }), JsxRuntime.jsxs(Stack.make, {
              children: [JsxRuntime.jsx(Title.make, {
                children: I18n.t(i18nPrefix + "receiving_disabled.title"),
                level: 4,
                weight: "bold",
                color: "#25243A"
              }), JsxRuntime.jsxs(InlineText.make, {
                children: [JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t(i18nPrefix + "receiving_disabled.content"),
                  size: "small"
                }), JsxRuntime.jsx(TextStyle.make, {
                  children: " "
                }), JsxRuntime.jsx(TextAction.make, {
                  text: I18n.t("Learn more"),
                  size: "compact",
                  onPress: () => HelpCenter.showArticle(HelpCenter.eInvoicingHowTo)
                })],
                wrap: false,
                linespace: "none"
              })],
              space: "xsmall"
            })],
            space: "xnormal",
            alignY: "top"
          }), JsxRuntime.jsx(Button.make, {
            label: I18n.t(i18nPrefix + "receiving_disabled.button_label"),
            variant: {
              NAME: "ghost",
              VAL: {
                bordered: true
              }
            },
            tone: "brand",
            trailingIcon: "external_link",
            href: enrollmentAgreementLink,
            target: "_blank",
            onPress: () => navigate(undefined, SettingsRoutes.electronicInvoicingRoute)
          })],
          space: "medium"
        }),
        spaceX: "normal",
        spaceY: "normal"
      })
    }))],
    space: "medium"
  });
}
let CardContent = {
  i18nPrefix: i18nPrefix,
  make: ElectronicInvoicingWorkflowState$CardContent
};
function ElectronicInvoicingWorkflowState$CardContainer(props) {
  let customerInvoicingAddress = props.customerInvoicingAddress;
  let featureState = props.featureState;
  console.log(featureState);
  let exit = 0;
  let receivingEnabled;
  let enrollmentAgreementLink;
  if (typeof featureState !== "object") {
    exit = 1;
  } else if (featureState.TAG === "Reloading") {
    let match = featureState._0;
    if (match.TAG === "Ok") {
      let match$1 = match._0;
      if (typeof match$1 !== "object") {
        exit = 2;
      } else {
        receivingEnabled = match$1.receivingEnabled;
        enrollmentAgreementLink = match$1.enrollmentAgreementLink;
        exit = 3;
      }
    } else {
      exit = 1;
    }
  } else {
    let match$2 = featureState._0;
    if (match$2.TAG !== "Ok") {
      return JsxRuntime.jsx(ElectronicInvoicing.Card.make, {
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Error"
        })
      });
    }
    let match$3 = match$2._0;
    if (typeof match$3 !== "object") {
      exit = 2;
    } else {
      receivingEnabled = match$3.receivingEnabled;
      enrollmentAgreementLink = match$3.enrollmentAgreementLink;
      exit = 3;
    }
  }
  switch (exit) {
    case 1:
      return JsxRuntime.jsx(ElectronicInvoicing.Card.make, {
        children: JsxRuntime.jsx(Placeholder.make, {
          status: "Loading"
        })
      });
    case 2:
      return JsxRuntime.jsx(ElectronicInvoicing.Card.make, {
        children: JsxRuntime.jsx(ElectronicInvoicing.InactiveCardContent.make, {}),
        featureState: "Inactive"
      });
    case 3:
      return JsxRuntime.jsx(ElectronicInvoicing.Card.make, {
        children: View.mapOption(props.data, data => JsxRuntime.jsx(ElectronicInvoicingWorkflowState$CardContent, {
          data: data,
          customerInvoicingAddress: customerInvoicingAddress,
          receivingEnabled: receivingEnabled,
          enrollmentAgreementLink: enrollmentAgreementLink
        })),
        featureState: {
          TAG: "Active",
          receivingEnabled: receivingEnabled
        }
      });
  }
}
let CardContainer = {
  make: ElectronicInvoicingWorkflowState$CardContainer
};
function ElectronicInvoicingWorkflowState$StatusBadgeContainer(props) {
  let data = props.data;
  let featureState = props.featureState;
  let exit = 0;
  if (typeof featureState !== "object") {
    exit = 1;
  } else if (featureState.TAG === "Reloading") {
    let match = featureState._0;
    if (match.TAG === "Ok") {
      let tmp = match._0;
      if (typeof tmp === "object") {
        return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$OptionalStatusBadge, {
          data: data
        });
      }
      exit = 2;
    } else {
      exit = 1;
    }
  } else {
    let match$1 = featureState._0;
    if (match$1.TAG !== "Ok") {
      return JsxRuntime.jsx(BackendFailure.Icon.make, {});
    }
    let tmp$1 = match$1._0;
    if (typeof tmp$1 === "object") {
      return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$OptionalStatusBadge, {
        data: data
      });
    }
    exit = 2;
  }
  switch (exit) {
    case 1:
      return JsxRuntime.jsx(Spinner.make, {
        size: 16
      });
    case 2:
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: I18n.t("Inactive"),
        labelVariation: "normal"
      });
  }
}
let StatusBadgeContainer = {
  make: ElectronicInvoicingWorkflowState$StatusBadgeContainer
};
let route = "electronic-invoice-workflow-state";
let __typename = "";
let stringJsonData = Json.encodeString("A json encoded string data");
let failureA = {
  __typename: __typename,
  kind: "InternalServerError",
  message: "An internal server error occured",
  data: stringJsonData
};
let failureB = {
  __typename: __typename,
  kind: "AuthIssue",
  message: "You are not correctly authenticated",
  data: stringJsonData
};
let issueA = {
  __typename: __typename,
  kind: "CecurityExampleIssue",
  message: "An issue happened on the Cecurity platform",
  data: stringJsonData
};
let loremIpsum = "Lorem ipsum dolor sit amet. Qui temporibus dolorem eos fugit nihil aut dolorem accusamus hic molestiae reiciendis? Ad ipsum ipsa ut laudantium deserunt est ipsum fugit et quae reprehenderit eum provident animi sit sint omnis aut atque officiis. Et magnam illum qui mollitia assumenda et incidunt ipsa ut dolores quisquam aut dolor aperiam aut pariatur deserunt eum quisquam unde. Traduction texte Et consequatur nostrum et molestiae internos qui possimus dolorum. Et itaque Quis hic suscipit quidem eum temporibus amet vel nostrum quidem et possimus earum qui consectetur culpa sit incidunt velit.";
let issueB_message = "A field is missing on the invoice A. " + loremIpsum;
let issueB = {
  __typename: __typename,
  kind: "CecurityMissingFieldExampleIssue",
  message: issueB_message,
  data: stringJsonData
};
function someDataWithFailures(failures) {
  return {
    __typename: __typename,
    value: undefined,
    failures: failures
  };
}
function someDataWithStatusAndIssues(status, issues) {
  return {
    __typename: __typename,
    value: {
      __typename: __typename,
      status: status,
      skipReason: undefined,
      issues: issues
    },
    failures: []
  };
}
function someDataWithStatusAndSkipReason(status, skipReason) {
  return {
    __typename: __typename,
    value: {
      __typename: __typename,
      status: status,
      skipReason: skipReason,
      issues: []
    },
    failures: []
  };
}
function cardFailingToLoadData(failuresOpt) {
  let failures = failuresOpt !== undefined ? failuresOpt : [];
  return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$CardContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithFailures(failures)
  });
}
function cardWithStatusAndIssues(status, issues) {
  return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$CardContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndIssues(status, issues)
  });
}
let styles = {
  section: {
    "borderColor-kVAM5u": "borderColor-xgpkd7n",
    "borderRadius-kaIpWk": "borderRadius-x12oqio5",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-x1xt58vq",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-x1c1vhfx",
    "padding-kmVPX3": "padding-xe8ttls",
    $$css: "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:805"
  },
  container: {
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "gap-kOIVth": "gap-xaobbuh",
    "maxWidth-ks0D6T": "maxWidth-x5rlx3t",
    "paddingBottom-kGO01o": "paddingBottom-xa7ez2e",
    "paddingLeft-kE3dHu": "paddingLeft-x5tiur9",
    "paddingRight-kpe85a": "paddingRight-x1s7jvk7",
    "paddingTop-kLKAdn": "paddingTop-x1cnzs8",
    "width-kzqmXN": "width-xvue9z",
    $$css: "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:816"
  },
  sectionTitle: {
    "fontSize-kGuDYH": "fontSize-xfifm61",
    "textAlign-k9WMMc": "textAlign-x2b8uid",
    "borderBottomColor-kL6WhQ": "borderBottomColor-x1rpwac6",
    "borderBottomStyle-kfdmCh": "borderBottomStyle-x1q0q8m5",
    "borderBottomWidth-kt9PQ7": "borderBottomWidth-x1f4sy7k",
    "display-k1xSpc": "display-x1lliihq",
    "marginBottom-k1K539": "marginBottom-xod5an3",
    "marginTop-keoZOQ": "marginTop-x1xmf6yo",
    "paddingBottom-kGO01o": "paddingBottom-x1120s5i",
    $$css: "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:827"
  }
};
let containerCss = {
  className: "display-x78zum5 flexDirection-xdt5ytf gap-xaobbuh maxWidth-x5rlx3t paddingBottom-xa7ez2e paddingLeft-x5tiur9 paddingRight-x1s7jvk7 paddingTop-x1cnzs8 width-xvue9z",
  "data-style-src": "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:816"
};
let sectionTitleCss = {
  className: "fontSize-xfifm61 textAlign-x2b8uid borderBottomColor-x1rpwac6 borderBottomStyle-x1q0q8m5 borderBottomWidth-x1f4sy7k display-x1lliihq marginBottom-xod5an3 marginTop-x1xmf6yo paddingBottom-x1120s5i",
  "data-style-src": "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:827"
};
let sectionCss = {
  className: "borderColor-xgpkd7n borderRadius-x12oqio5 borderStyle-x1y0btm7 borderWidth-x1xt58vq alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf gap-x1c1vhfx padding-xe8ttls",
  "data-style-src": "wino-gc:src/modules/ElectronicInvoicing/ElectronicInvoicingWorkflowState.res.js:805"
};
function sectionTitle(title) {
  let newrecord = {
    ...sectionTitleCss
  };
  return JsxRuntime.jsx("h3", (newrecord.children = title, newrecord));
}
function ElectronicInvoicingWorkflowState$Dev(props) {
  let newrecord = {
    ...containerCss
  };
  let newrecord$1 = {
    ...sectionCss
  };
  newrecord.children = [JsxRuntime.jsxs("section", (newrecord$1.children = [sectionTitle("Badges container in various states"), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: "Inactive"
      }
    },
    data: undefined
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithFailures([failureA])
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndIssues({
      NAME: "FutureAddedValue",
      VAL: "Unknown status"
    }, [])
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndIssues("publicationPending", [])
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndSkipReason("publicationSkipped", "b2cInvoice")
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndIssues("postPublicationBlocked", [issueA])
  }), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$StatusBadgeContainer, {
    featureState: {
      TAG: "Done",
      _0: {
        TAG: "Ok",
        _0: {
          TAG: "Active"
        }
      }
    },
    data: someDataWithStatusAndIssues("postPublicationCompleted", [])
  })], newrecord$1)), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card when the account is inactive"), JsxRuntime.jsx(ElectronicInvoicingWorkflowState$CardContainer, {
      featureState: {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: "Inactive"
        }
      },
      data: undefined
    })]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card failing to load data"), cardFailingToLoadData(undefined)]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card failing to load data with a single failure details"), cardFailingToLoadData([failureA])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card failing to load data with multiple failures details"), cardFailingToLoadData([failureA, failureB])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with unknown status"), cardWithStatusAndIssues({
      NAME: "FutureAddedValue",
      VAL: "Unknown"
    }, [])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with publicationPending status"), cardWithStatusAndIssues("publicationPending", [])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with publicationBlocked status"), cardWithStatusAndIssues("publicationBlocked", [issueA])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with postPublicationStarted status"), cardWithStatusAndIssues("postPublicationStarted", [])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with postPublicationBlocked status"), cardWithStatusAndIssues("postPublicationBlocked", [issueA, issueB])]
  }), JsxRuntime.jsxs("section", {
    children: [sectionTitle("Card with postPublicationCompleted status"), cardWithStatusAndIssues("postPublicationCompleted", [])]
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let Dev_unknownStatus = {
  NAME: "FutureAddedValue",
  VAL: "An unknown status"
};
let Dev = {
  route: route,
  __typename: __typename,
  stringJsonData: stringJsonData,
  failureA: failureA,
  failureB: failureB,
  issueA: issueA,
  loremIpsum: loremIpsum,
  issueB: issueB,
  unknownStatus: Dev_unknownStatus,
  someDataWithFailures: someDataWithFailures,
  someDataWithStatusAndIssues: someDataWithStatusAndIssues,
  someDataWithStatusAndSkipReason: someDataWithStatusAndSkipReason,
  cardFailingToLoadData: cardFailingToLoadData,
  cardWithStatusAndIssues: cardWithStatusAndIssues,
  styles: styles,
  containerCss: containerCss,
  sectionTitleCss: sectionTitleCss,
  sectionCss: sectionCss,
  sectionTitle: sectionTitle,
  make: ElectronicInvoicingWorkflowState$Dev
};
function designSystemPage_view() {
  return JsxRuntime.jsx(ElectronicInvoicingWorkflowState$Dev, {});
}
let designSystemPage = {
  route: route,
  view: designSystemPage_view
};
export { label, ResultFragment, backendFailure, failureKindToTitle, skipReasonToMessage, map, StatusBadge, OptionalStatusBadge, IssueBox, PublicationSkippedInfoBox, DataBoxList, isCardContentExpandable, CardContent, CardContainer, StatusBadgeContainer, Dev, designSystemPage };
/* label Not a pure module */